import {
  useState,
  createContext,
  useContext,
  ReactNode,
  useEffect,
  SetStateAction,
  Dispatch,
} from 'react'

export type SubmissionType = 'film' | 'series'
interface IBulkSubmissionContext {
  type: SubmissionType
  step: number
  updateStep: (step: number) => void
  setType: Dispatch<SetStateAction<SubmissionType>>
}

const BulkSubmissionContext = createContext<IBulkSubmissionContext>({
  type: 'film',
  step: 0,
  updateStep: (_step: number) => 0,
  setType: () => 0,
})

export const BulkSubmissionProvider = ({ children }: { children: ReactNode }) => {
  const [step, setStep] = useState(0)
  const [type, setType] = useState<SubmissionType>('film')

  const updateStep = (_step: number) => {
    setStep(_step)
  }

  useEffect(() => {
    console.log(step, type)
  }, [step, type])

  return (
    <BulkSubmissionContext.Provider value={{ step, updateStep, type, setType }}>
      {children}
    </BulkSubmissionContext.Provider>
  )
}

export const useBulkSubmissions = () => useContext(BulkSubmissionContext)
